export default __webpack_public_path__ + "static/media/loader_bnb.1889daf7.gif";